export default __webpack_public_path__ + "static/media/admin-header-on.c5e2defe.svg";